export { BikeParkingIcon } from './BikeParkingIcon'
